export const CSV_SCHEMA = [
  {
    field: "name",
    label: "Product Name",
    required: true,
    type: "String",
    format: "Any text",
    example: "Canned Milk 500ml",
  },
  {
    field: "category",
    label: "Category",
    required: true,
    type: "String",
    format: "Any text",
    example: "Beverages",
  },
  {
    field: "cost_price",
    label: "Cost Price",
    required: true,
    type: "Number",
    format: "Numeric only — no symbols or commas (e.g. 50.00)",
    example: "50.00",
  },
  {
    field: "selling_price",
    label: "Selling Price",
    required: true,
    type: "Number",
    format: "Numeric only — no symbols or commas (e.g. 75.50)",
    example: "75.50",
  },
  {
    field: "quantity",
    label: "Initial Quantity",
    required: false,
    type: "Number",
    format: "Whole number (e.g. 100)",
    example: "100",
  },
] as const;

export const productFields: Record<string, string> = {
  name: "Product Name",
  category: "Category",
  cost_price: "Cost Price",
  selling_price: "Selling Price",
  quantity: "Initial Quantity",
};
